module.exports = __webpack_public_path__ + "static/media/june2023-5.d974df73.webp";